import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,
  Button,Selector,Ellipsis,Image,SideBar,NavBar,Tabs,FloatingBubble,Grid,Toast
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, LikeOutline,BellOutline,MessageFill,UploadOutline } from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import {
    GetDataDictionarysByCode,PostAlbumClass,SaveAlbumClass
  } from '../../service/service';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            userInfo: {},
            tabIdx: 0,
            navIdx: 0,

            navList: [],
            tabList: [],
        };
    }

    componentDidMount() {
        console.log(this.props.userInfo);
        var that = this;

        GetDataDictionarysByCode("XiangCeLX").then(res => {
            if (res.success) {
                var arry = [];
                var tabIdx = 0;
                res.result.map((item, index) => {
                    if (index == 0) {
                        tabIdx = item.id;
                        that.setState({
                            tabIdx: item.id
                        })
                    }
                    arry.push({ name: item.displayName, id: item.id })
                })
                that.loadData(tabIdx);
                that.setState({
                    tabList: arry,
                    tabIdx: tabIdx,
                })
            }
        })

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }

    loadData = (tabIdx) => {
        var that = this;
        const { location } = that.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            that.setState({
                id: id,
            })

            const data = {
                PlanetId: id,
                MaxResultCount: 999,
                SkipCount: 0,
                TabTypeId: tabIdx === 0 ? undefined : tabIdx
            };
            PostAlbumClass(data).then(res => {
                if (res.success) {
                    var list = [];
                    res.result.map(item => {
                        list.push({
                            id: item.id,
                            name: item.name,
                        })
                    })
                    that.setState({
                        navList: list
                    })
                }
            })
        }
    }

    submitForm = () => {
        var that = this;
        var list = [];
        that.state.navList.map(item => {
            list.push({
                Id: item.id < 0 ? 0 : item.id,
                TabTypeId: that.state.tabIdx,
                Name: item.name,
                PlanetId: that.state.id,
                CreatorUserId: that.state.userInfo.id
            })
        })

        const isDuplicate = () => {
            const names = this.state.navList.map(item => item.name);
            const uniqueNames = new Set(names);
            return names.length === uniqueNames.size; // 如果长度一致，说明没有重复
        };
        if (!isDuplicate()) {
            // 提示用户名称重复
            Toast.show({ content: '名称重复，请使用其他名称！' });
            return;
        }

        var data = {
            AlbumClassDtos: list
        };
        SaveAlbumClass(data).then(res => {
            if (res.success) {
                Toast.show({ icon: 'success', content: '提交成功！' });
                setTimeout(() => {
                    that.props.navigate('/albumClass', { replace: true, state: { id: that.state.id } }); // 传递状态
                }, 2000);
            }
        })
    }
    


    render() {


        return (
            <div style={{
                height: "100%", width: "100%", overflow: "auto",
                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/37-39-08.png')"
                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%"
            }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/albumClass', { replace: true, state: { id: this.state.id } }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', 'height': "6%" }}>
                    编辑
                </NavBar>

                <div>
                    <div style={{ marginTop: "10px" }}>
                        <div style={{
                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/34-10.png')"
                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "6%",
                            display: "flex", flexDirection: "row", width: "80%", marginLeft: "10%"
                        }}>
                            {
                                this.state.tabList.map(item => {
                                    var width = 100 / this.state.tabList.length;
                                    return (
                                        <div style={{
                                            width: width + "%", height: "100%", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                            backgroundImage: this.state.tabIdx == item.id ?
                                                "url('https://api.weibinyi.com/images/niannian/4/34-09.png')" : ""
                                            , textAlign: "center", lineHeight: "41px", color: "#fff", fontSize: "15px"
                                        }} onClick={() => {
                                            this.setState({
                                                tabIdx: item.id
                                            })
                                            this.loadData(item.id);
                                        }}>
                                            {item.name}
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div style={{
                            width: "80%", marginLeft: "10%", backgroundColor: "#fff",
                            paddingTop: "5px", marginBottom: "90px"
                        }}>
                            <div>
                                <Form layout='horizontal'>
                                    {
                                        this.state.navList.map(item => {
                                            return (
                                                <div>
                                                    <Form.Item label="名称" name={'username' + item.id} extra={
                                                        <a style={{ fontSize: "13px", color: "#f00" }}
                                                            onClick={() => {
                                                                // 删除功能实现
                                                                this.setState(prevState => ({
                                                                    navList: prevState.navList.filter(navItem => navItem.id !== item.id)
                                                                }));
                                                            }}>删除</a>
                                                    }>
                                                        <Input placeholder='修改名称'
                                                            value={item.name}  // 绑定当前值
                                                            defaultValue={item.name}  // 绑定当前值
                                                            onChange={(e) => {
                                                                const newName = e;
                                                                // 检查是否有重复的name
                                                                const isDuplicate = this.state.navList.some(
                                                                    navItem => navItem.name === newName && navItem.id !== item.id
                                                                );

                                                                if (isDuplicate) {
                                                                    // 提示用户名称重复
                                                                    Toast.show({ content: '名称已存在，请使用其他名称！' });
                                                                } else {
                                                                    // 没有重复，更新状态
                                                                    this.setState(prevState => ({
                                                                        navList: prevState.navList.map(navItem =>
                                                                            navItem.id === item.id ? { ...navItem, name: newName } : navItem
                                                                        )
                                                                    }));
                                                                }
                                                            }} />
                                                    </Form.Item>
                                                </div>
                                            );
                                        })
                                    }
                                </Form>
                                <div style={{ textAlign: "center", marginTop: "13px", color: "#f00" }}>
                                    提示：点击文字可直接进行编辑
                                </div>
                                <div style={{
                                    display: "flex", justifyContent: "center", alignItems: "center",
                                    margin: "25px 0px 25px 0px"
                                }}>
                                    <Image
                                        src={"https://api.weibinyi.com/images/niannian/4/2-12.png"}
                                        fit='cover' width={50} height={50} onClick={()=>{
                                            var navList = this.state.navList;
                                            var minId = 0; // 默认值

                                            if (navList.length > 0) {
                                                // 找到数组中最小的id
                                                minId = Math.min(...navList.map(item => item.id));
                                            }

                                            // 计算新项的id
                                            var newItemId = minId > 0 ? -1 : minId - 1;

                                            var newItem = { id: newItemId, name: "待修改" };

                                            var list = navList.concat(newItem);
                                            if (list.length >= 7) {
                                                Toast.show({ content: '无法新增（总数已满）！' });
                                                return;
                                            }
                                            this.setState({
                                                navList: list
                                            });
                                        }}
                                    />
                                </div>
                                <div style={{ paddingBottom: "20px" }}>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                        , fontWeight: "600", color: "#fff"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        确 定
                            </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>


                <BottomMenu  position="fixed" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);